import React from "react";
import config from "../data/config";

const SideStoriesWrapper = ({
  storyChangeHandler,
  currStoryId,
  categoryListData,
}) => {
  return (
    <div className="stories-wrapper">
      {categoryListData &&
        categoryListData.map((item, index) => {
          return (
            <div
              onClick={() => storyChangeHandler(index + 1)}
              className={`story-thumb-block ${
                Number(currStoryId) === index + 1 ? "active" : ""
              } ${index === categoryListData.length - 1 ? "d-none" : ""}`}
              key={index}
            >
              <div className="story-thumb-img">
                <img
                  src={`${config.BUCKET_URL}${item?.thumbnail_relative_path}`}
                  alt=""
                />
              </div>
              <div className="story-thumb-text">
                <span>{item.category_name}</span>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default SideStoriesWrapper;
